import { cardApi } from "@/core/data/api";

export default async (cardId) => {
  return await cardApi.removeCardOwner(cardId);
};
